import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import wallet1 from "../../Assets/images/wallet-dummy.png";
import "swiper/css";
import "swiper/css/navigation";

const Wallet = () => {
  return (
    <>
      <section className="relative">
        <div className="w-full relative container py-20">
          <div className="w-full justify-center lg:justify-start lg:items-start items-center flex mb-8    sm:mb-16">
            <h2 className=" text-2xl sm:text-3xl text-center font-bold  bg-gradient-to-r from-yellow-500 via-blue-500 to-gray-600  text-transparent bg-clip-text mb-2 ">
              Stay tuned — our app is launching soon!
            </h2>
          </div>

          <Swiper
            modules={[Navigation]}
            loop={true}
            slidesPerView={3}
            spaceBetween={20}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            breakpoints={{
              1920: { slidesPerView: 3, spaceBetween: 30 },
              1024: { slidesPerView: 3, spaceBetween: 30 },
              575: { slidesPerView: 2, spaceBetween: 30 },
              320: { slidesPerView: 1, spaceBetween: 10 },
            }}
            className="swiper multiple-slide-carousel "
          >
            <SwiperSlide className="  ">
              <div className="swiper-bg  p-4 rounded-2xl h-full flex justify-center items-center">
                <div
                  className="px-1.5  swiper-bgg bg-[#08121f57] rounded-2xl  "
                  tabIndex={-1}
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className=" px-10 md:px-12 pb-4 md:pb-9  rounded-3xl space-y-2.5 blur-[3px]">
                    <div className="text-center">
                      <img
                        src={wallet1}
                        alt="Ox Change App screen 2"
                        className=" -hue-rotate-90 mx-auto "
                      />
                    </div>
                    <h2 className="text-sm md:text-lg font-bold text-light bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text">
                      Add some <span className="text-foreground">$MATIC</span>{" "}
                      to the wallet so you can swap it for{" "}
                      <span className="gradiant-text">$ExBit</span>
                    </h2>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="swiper-bg p-4 rounded-2xl h-full flex justify-center items-center">
                <div
                  className="px-1.5 swiper-bgg bg-[#08121f57] rounded-2xl  "
                  tabIndex={-1}
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className="bg-dark px-10 md:px-12 pt-4 md:pt-9  rounded-3xl space-y-2.5 blur-[3px]">
                    <h2 className="text-sm md:text-lg font-bold text-light bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text">
                      Add some <span className="text-foreground">$MATIC</span>{" "}
                      to the wallet so you can swap it for{" "}
                      <span className="gradiant-text">$ExBit</span>
                    </h2>
                    <div className="text-center">
                      <img
                        src={wallet1}
                        alt="Ox Change App screen 2"
                        className=" -hue-rotate-90 mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="swiper-bg p-4 rounded-2xl h-full flex justify-center items-center">
                <div
                  className="px-1.5 swiper-bgg bg-[#08121f57] rounded-2xl  "
                  tabIndex={-1}
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className="bg-dark px-10 md:px-12 pb-4 md:pb-9  rounded-3xl space-y-2.5 blur-[3px]">
                    <div className="text-center">
                      <img
                        src={wallet1}
                        alt="Ox Change App screen 2"
                        className="-hue-rotate-90 mx-auto"
                      />
                    </div>
                    <h2 className="text-sm md:text-lg font-bold text-light bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text">
                      Add some <span className="text-foreground">$MATIC</span>{" "}
                      to the wallet so you can swap it for{" "}
                      <span className="gradiant-text">$ExBit</span>
                    </h2>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="swiper-bg p-4 rounded-2xl h-full flex justify-center items-center">
                <div
                  className="px-1.5 swiper-bgg bg-[#08121f57] rounded-2xl  "
                  tabIndex={-1}
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className="bg-dark px-10 md:px-12 pt-4 md:pt-9  rounded-3xl space-y-2.5 blur-[3px]">
                    <h2 className="text-sm md:text-lg font-bold text-light bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text">
                      Add some <span className="text-foreground">$MATIC</span>{" "}
                      to the wallet so you can swap it for{" "}
                      <span className="gradiant-text">$ExBit</span>
                    </h2>
                    <div className="text-center">
                      <img
                        src={wallet1}
                        alt="Ox Change App screen 2"
                        className="-hue-rotate-90 mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="swiper-bg p-4 rounded-2xl h-full flex justify-center items-center">
                <div
                  className="px-1.5 swiper-bgg bg-[#08121f57] rounded-2xl  "
                  tabIndex={-1}
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className="bg-dark px-10 md:px-12 pb-4 md:pb-9  rounded-3xl space-y-2.5 blur-[3px]">
                    <div className="text-center">
                      <img
                        src={wallet1}
                        alt="Ox Change App screen 2"
                        className="-hue-rotate-90 mx-auto"
                      />
                    </div>
                    <h2 className="text-sm md:text-lg font-bold text-light bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text">
                      Add some <span className="text-foreground">$MATIC</span>{" "}
                      to the wallet so you can swap it for{" "}
                      <span className="gradiant-text">$ExBit</span>
                    </h2>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="swiper-bg p-4 rounded-2xl h-full flex justify-center items-center">
                <div
                  className="px-1.5 swiper-bgg bg-[#08121f57] rounded-2xl  "
                  tabIndex={-1}
                  style={{ width: "100%", display: "inline-block" }}
                >
                  <div className="bg-dark px-10 md:px-12 pt-4 md:pt-9  rounded-3xl space-y-2.5 blur-[3px]">
                    <h2 className="text-sm md:text-lg font-bold text-light bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 inline-block text-transparent bg-clip-text">
                      Add some <span className="text-foreground">$MATIC</span>{" "}
                      to the wallet so you can swap it for{" "}
                      <span className="gradiant-text">$ExBit</span>
                    </h2>
                    <div className="text-center">
                      <img
                        src={wallet1}
                        alt="Ox Change App screen 2"
                        className="-hue-rotate-90 mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          <div className="absolute flex items-center  right-16 w-fit ">
            <button className="swiper-button-prev group !p-2 flex justify-center items-center border border-solid border-blue-600 !w-12 !h-12 transition-all duration-500 rounded-full hover:bg-blue-600 !-translate-x-16">
              <svg
                className="h-3 w-3 text-blue-600 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M10.0002 11.9999L6 7.99971L10.0025 3.99719"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button className="swiper-button-next group !p-2 flex justify-center items-center border border-solid border-blue-600 !w-12 !h-12 transition-all duration-500 rounded-full hover:bg-blue-600 !translate-x-16">
              <svg
                className="h-3 w-3 text-blue-600 group-hover:text-white"
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M5.99984 4.00012L10 8.00029L5.99748 12.0028"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Wallet;
